/*
 * Author M. Atoar Rahman
 * Title: Partner Stock Return
 * Description: Page for Partner Stock Return
 * Date: 19/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { PartnerStockReturnProvider } from '../partner/stockReturn/ContextAPI';
import Index from '../partner/stockReturn/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerStockReturn() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-stock-return']) return <PermissionDenied />;

    return (
        <PartnerStockReturnProvider>
            <Index />
        </PartnerStockReturnProvider>
    );
}
